import { render, staticRenderFns } from "./verCaja.vue?vue&type=template&id=7b5e609a&scoped=true&"
import script from "./verCaja.vue?vue&type=script&lang=js&"
export * from "./verCaja.vue?vue&type=script&lang=js&"
import style0 from "./verCaja.vue?vue&type=style&index=0&id=7b5e609a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5e609a",
  null
  
)

export default component.exports